import { formatDate } from "@/lib/helpers";
import { FileText, Upload } from "lucide-react";

// Student Detail -> "Documents & Signed Forms" card. Extracted from
// StudentDetail.js (props-driven, no behavior change).
export const DocumentsCard = ({ documents, onUpload }) => (
  <section className="rounded-[var(--radius)] border bg-card p-4 sm:p-5 space-y-3" data-testid="documents-card">
    <div className="flex items-center justify-between">
      <h2 className="font-semibold font-heading flex items-center gap-2"><FileText className="h-4 w-4" /> Documents & Signed Forms</h2>
      <label className="cursor-pointer">
        <input type="file" className="hidden" onChange={onUpload} data-testid="student-document-upload-input" />
        <span className="inline-flex items-center gap-2 text-sm text-[hsl(var(--role-accent))] font-medium">
          <Upload className="h-4 w-4" /> Upload
        </span>
      </label>
    </div>
    {documents.length === 0 ? (
      <p className="text-sm text-muted-foreground">No documents uploaded yet.</p>
    ) : (
      <div className="divide-y">
        {documents.map((d) => (
          <a key={d.id} href={`${process.env.REACT_APP_BACKEND_URL}${d.file_url}`} target="_blank" rel="noreferrer" className="flex items-center justify-between py-2 hover:text-[hsl(var(--role-accent))]" data-testid="student-document-row">
            <span className="text-sm font-medium truncate">{d.category} {d.file_name ? `(${d.file_name})` : ""}</span>
            <span className="text-xs text-muted-foreground shrink-0">{formatDate(d.uploaded_at)}</span>
          </a>
        ))}
      </div>
    )}
  </section>
);
